<script>
import "./signinCss";
import moment from "moment";
import { sDs } from "@common/sDs/sDs.js";
import { library } from "@common/library/library.js";
import { componentStore } from "@common/componentStore/componentStore.js";
import { controlStore, createStoreIndex } from "@common/control/controlStore";
import { signinStore } from "@signin/signinStore";

const rosterConfig = {
    cId: 'roster',
    cType: "roster",
    cTitle: "Open Roster",
    cTemplate: '<div id="roster" class="signin-roster signin-css">'
        + '        <div v-if="!componentLoading" class="signin-login container">'
        + '            <div v-show="controlValue(\'ROSTER_EMPTY_LIST\')">'
        + '                <div v-if="!rosterForgotList || rosterForgotList.length == 0">'
        + '                    <control name="ROSTER_EMPTY_LIST"></control>'
        + '                </div>'
        + '            </div>'
        + '            <control name="ROSTER_LIST" :items="rosterFilteredList"></control>'
        + '            <div v-if="rosterForgotList && rosterForgotList.length > 0">'
        + '                <control name="ROSTER_FORGOT_MESSAGE"></control>'
        + '            </div>'
        + '            <control name="ROSTER_FORGOT_LIST" :items="rosterForgotList"></control>'
        + '        </div>'
        + '     </div>',
    controls: [
        {
            name: 'ROSTER_SHOW_GROUP_SIZE',
            type: "button",
            label: "DD.SIGNIN2_OPTIONS.ROSTER_SHOW_GROUP_SIZE",
            onclick: "showGroupSize",
            cssClass: "e-link"
        },
        {
            name: 'ROSTER_GROUP_SIZE',
            type: "number",
            onchange: "changeGroupSize",
            min: 1,
            max: 999,
            format: "###"
        },
        {
            name: 'ROSTER_SIGN_IN',
            type: "button",
            label: "Sign In",
            onclick: "signIn",
            cssClass: "e-success"
        },
        {
            name: 'ROSTER_SIGN_OUT',
            type: "button",
            label: "DD.SIGNIN2_OPTIONS.ROSTER_SIGN_OUT",
            onclick: "signOut",
            cssClass: "e-danger"
        },
        {
            name: 'ROSTER_SIGN_IN_AGAIN',
            type: "button",
            label: "DD.SIGNIN2_OPTIONS.ROSTER_SIGN_IN_AGAIN",
            onclick: "signInAgain",
            cssClass: "e-link"
        },
        {
            name: 'ROSTER_LIST',
            type: "list",
            itemContentTemplate: "<div class=\"col-xs-12 col-sm-12 col-md-6 fl mb10\" :data-test-id=\"dataTestId+'_'+data.key\">"
                    + "        <div class=\"list-item-title\" v-show=\"controlValue('SIS_SORT_ROSTER_BY') == 2\">"
                    + "            {{data.volunteer.VOL_LAST_NAME}}, {{data.volunteer.VOL_FIRST_NAME}} {{data.volunteer.VOL_EMAIL ? '('+ data.volunteer.VOL_EMAIL + ')' : ''}}"
                    + "        </div>"
                    + "        <div class=\"list-item-title\" v-show=\"controlValue('SIS_SORT_ROSTER_BY') != 2\">"
                    + "             {{data.volunteer.VOL_FIRST_NAME}} {{data.volunteer.VOL_LAST_NAME}} {{data.volunteer.VOL_EMAIL ? '('+ data.volunteer.VOL_EMAIL + ')' : ''}}"
                    + "        </div>"
                    + "           <div class=\"list-item-subtitle\">"
                    + "             {{data.slot.SS_START_TIME}} - {{data.slot.SS_FINISH_TIME}}&nbsp;{{data.slot.OPP_TITLE}}"
                    + "        </div>"
                    + "        </div>"
                    + "        <div class=\"col-xs-12 col-sm-12 col-md-6 fl pt0 mb10\">"
                    + "            <div class=\"col-xs-6 col-sm-6 col-md-5 fl pt0\" v-show=\"controlValue('SIS_HIDE_GROUP_SIGNIN') == 0 && !data.TIME_LOGGED\">"
                    + "                <div v-show=\"data.show_group_size == 0 && !data.SLOT_SIGNED_IN\">"
                    + "                    <control :name=\"'ROSTER_SHOW_GROUP_SIZE'\" :actionParams=\"data\"></control>"
                    + "                </div>"
                    + "                <div v-show=\"data.show_group_size == 1\">"
                    + "                     <control :name=\"'ROSTER_GROUP_SIZE__'+data.key\" :actionParams=\"data\"></control>"
                    + "                </div>"
                    + "            </div>"
                    + "            <div class=\"col-xs-6 col-sm-6 col-md-7 fr pt0\" v-show=\"!data.TIME_LOGGED\">"
                    + "                 <div v-show=\"!data.SLOT_SIGNED_IN\">"
                    + "                     <control :name=\"'ROSTER_SIGN_IN__'+data.key\" :actionParams=\"data\"></control>"
                    + "                 </div>"
                    + "                 <div v-show=\"data.SLOT_SIGNED_IN\">"
                    + "                      <control :name=\"'ROSTER_SIGN_OUT'\" :actionParams=\"data\"></control>"
                    + "                 </div>"
                    + "            </div>"
                    + "            <div class=\"col-xs-6 col-sm-6 col-md-7 fr pt0 time-logged\" v-show=\"data.TIME_LOGGED\">"
                    + "                 Time Logged<span class=\"fa fa-check signed-in-checkmark\"></span><br/>"
                    + "                 <control :name=\"'ROSTER_SIGN_IN_AGAIN__'+data.key\" :actionParams=\"data\"></control>"
                    + "            </div>"
                    + "        </div> <div class='clearfix'></div>"
        },
        {
            name: 'ROSTER_FORGOT_LIST',
            type: "list",
            itemContentTemplate: "<div class=\"col-xs-12 col-sm-12 col-md-5 fl\" :data-test-id=\"dataTestId+'_'+data.key\">"
                    + "        <div class=\"list-item-title\" v-show=\"controlValue('SIS_SORT_ROSTER_BY') == 2\">"
                    + "            {{data.volunteer.VOL_LAST_NAME}}, {{data.volunteer.VOL_FIRST_NAME}} {{data.volunteer.VOL_EMAIL ? '('+ data.volunteer.VOL_EMAIL + ')' : ''}}"
                    + "        </div>"
                    + "        <div class=\"list-item-title\" v-show=\"controlValue('SIS_SORT_ROSTER_BY') != 2\">"
                    + "             {{data.volunteer.VOL_FIRST_NAME}} {{data.volunteer.VOL_LAST_NAME}} {{data.volunteer.VOL_EMAIL ? '('+ data.volunteer.VOL_EMAIL + ')' : ''}}"
                    + "        </div>"
                    + "        <div class=\"list-item-subtitle\">"
                    + "             You forgot to sign out on {{data.volunteer.LOGBOOK_START_DATE_COL}}<br>{{data.volunteer.OPP_TITLE}}"
                    + "        </div>"
                    + "        </div>"
                    + "        <div>&#160;</div>"
                    + "        <div class=\"col-xs-12 col-sm-12 col-md-7 fl pt0\">"
                    + "            <div class=\"col-xs-6 col-sm-6 col-md-6 fr\" v-show=\"!data.TIME_LOGGED\">"
                    + "               <control :name=\"'ROSTER_SIGN_OUT'+''\" :actionParams=\"data\"></control>"
                    + "            </div>"
                    + "        </div><div class='clearfix'></div>"
        },
        {
            name: 'SIS_SORT_ROSTER_BY',
            asField: true,
            type: "dropdown",
            default: 2
        },
        {
            name: 'SIS_HIDE_GROUP_SIGNIN',
            asField: true,
            type: "boolean",
            default: false
        },
        {
            name: 'SIS_HIDE_VOL_FROM_ROSTER',
            asField: true,
            type: "boolean",
            default: false
        },
        {
            name: 'ROSTER_EMPTY_LIST',
            asField: true,
            type: "alert",
            default: false
        },
        {
            name: 'ROSTER_FORGOT_MESSAGE',
            asField: true,
            value: "DD.SIGNIN2_OPTIONS.ROSTER_FORGOT_MESSAGE",
            type: "info"
        }
    ]
};

let rosterCmp = {
    props: {
        stationId: {
            default: false
        }
    },
    data() {
        return {
            rosterList: {},
            rosterFilteredList: {},
            rosterForgotList: {},
            slots: {},
            volunteers: {},
            oppIds: {},
            volIds: {},
        };
    },
    name: 'roster',
    preInitControls: true,
    computed: {
        signinStore() {
            return signinStore.state;
        }
    },
    methods: {
        handleSignInOutResponses(response) {
            library.hideLoadingIndicator('roster');
            if (response.status === 'success') {
                this.loadLogBookEntries();
            } else {
                if (response.error) {
                    let message;
                    if (Array.isArray(response.error)) {
                        message = response.error.join('<br>');
                    }
                    if (typeof response.error === 'string') {
                        message = response.error;
                    }
                    library.showToast(message);
                }

                /* istanbul ignore next */
                this.loadScheduledSlots();
            }
        },
        signIn: function (event, controlConfig, volunteer) {
            let stationId = this.stationId;
            let volId = volunteer.volunteer.ID;
            let oppId = volunteer.slot.OPPORTUNITY_ID;
            let slotId = volunteer.slot.ID;
            let baseSlotIdLen = 6;
            if (volunteer.slot.moreThanOneDay) {
                if (typeof volunteer.slot.ID !== 'string') volunteer.slot.ID += '';
                /* istanbul ignore next */
                slotId = volunteer.slot.ID.substring(0, volunteer.slot.ID.length - baseSlotIdLen);
            }
            let groupSize = volunteer.group_size;
            if (stationId && volId && oppId) {
                library.showLoadingIndicator('roster');
                this.sDs.post("er_SISSignIn", stationId, volId, oppId, slotId, groupSize).then((response) => {
                    this.handleSignInOutResponses(response);
                });
            }
        },
        signOut: function (event, controlConfig, volunteer) {
            let stationId = this.stationId;
            let volId = volunteer.volunteer.ID;
            if (stationId && volId) {
                library.showLoadingIndicator('roster');
                this.sDs.post("er_SISSignOut", stationId, volId).then((response) => {
                    this.handleSignInOutResponses(response);
                });
            }
        },
        signInAgain: function (event, controlConfig, clickParams) {
            this.controls['ROSTER_LIST'].items[clickParams.key].TIME_LOGGED = false;
        },
        showGroupSize: function (event, controlConfig, clickParams) {
            this.controls['ROSTER_LIST'].items[clickParams.key].show_group_size = true;
            this.controls["ROSTER_GROUP_SIZE__" + clickParams.key].value = clickParams.group_size;
        },
        changeGroupSize: function (event, controlConfig, changeParams) {
            this.controls['ROSTER_LIST'].items[changeParams.key].group_size = controlConfig.value;
            this.controls["ROSTER_SIGN_IN__" + changeParams.key].label = controlConfig.value > 1 ? 'Sign In with ' + controlConfig.value : 'Sign In';
        },
        loadLogBookEntries: function () {
            if (this.volIds && this.oppIds) {
                this.controls['ROSTER_FORGOT_LIST'].items = [];
                let sDsParams = {
                    sDsParams: {
                        force: true
                    }
                };
                library.showLoadingIndicator('roster');
                this.sDs.post("er_getLbeList", this.volIds, this.oppIds, false, false, false, false, "LOGBOOK_ENTERED_DATE_COL", "LD_NAME", false, false, false, true, false, false, "mi", false, true, sDsParams).then((response) => {
                    library.hideLoadingIndicator('roster');
                    if (response && response.status === 'success') {
                        let rosterList = library.cloneObj(this.rosterList);
                        let volunteers = library.cloneObj(this.volunteers);
                        let rosterForgotList = [];
                        for (let i in response.data) {
                            if (i === 'length') continue;
                            let lbe = response.data[i];
                            let isClean = !!((lbe.LBE_VALUE === "" || lbe.LBE_VALUE === null) && (lbe.SIGN_OUT_STATION_ID === "" || lbe.SIGN_OUT_STATION_ID === null));

                            let cleanLbeAdded = false;
                            for (let j in rosterList) {
                                if (j === 'length') continue;
                                let rosterItem = library.cloneObj(rosterList[j]);
                                if ((rosterItem.volunteer.SCHEDULE_SLOT_ID === lbe.SCHEDULE_SLOT_ID || rosterItem.slot.value === lbe.SCHEDULE_SLOT_ID) && rosterItem.volunteer.ID === lbe.VOL_ID) {
                                    if (isClean) {
                                        rosterList[j].SLOT_SIGNED_IN = true;
                                        rosterList[j].TIME_LOGGED = false;
                                        cleanLbeAdded = true;
                                    } /* istanbul ignore next */ else if (!isClean && lbe.SIGN_OUT_STATION_ID && lbe.SIGN_OUT_STATION_ID !== "") {
                                        rosterList[j].SLOT_SIGNED_IN = false;
                                        rosterList[j].TIME_LOGGED = true;
                                    }
                                }
                            } /* istanbul ignore next */
                            if (isClean && !cleanLbeAdded && volunteers && volunteers[lbe.VOL_ID]) {
                                let cleanLbeForgotSignOut = {};
                                cleanLbeForgotSignOut.volunteer = {};
                                cleanLbeForgotSignOut.volunteer["ID"] = lbe.VOL_ID;
                                cleanLbeForgotSignOut.volunteer["LOG_BOOK_ENTRY_ID"] = lbe.LOG_BOOK_ENTRY_ID;
                                cleanLbeForgotSignOut.volunteer["OPP_TITLE"] = lbe.LOGBOOK_OPP_TITLE;
                                let startDate = lbe.LOGBOOK_START_DATE_COL.replace(/\./g, "-");
                                startDate = moment(startDate).format("DD MMM YYYY");
                                cleanLbeForgotSignOut.volunteer["LOGBOOK_START_DATE_COL"] = startDate;
                                for (let prop in volunteers[lbe.VOL_ID]) {
                                    if (prop === 'length') continue;
                                    cleanLbeForgotSignOut.volunteer[prop] = library.cloneObj(volunteers[lbe.VOL_ID][prop]);
                                }
                                rosterForgotList.push(cleanLbeForgotSignOut);
                            }
                        }
                        this.rosterList = rosterList;
                        this.rosterForgotList = rosterForgotList;
                        this.filterRosterList();
                    } /* istanbul ignore next */ else {
                        this.filterRosterList();
                    }
                });
            } /* istanbul ignore next */ else {
                this.filterRosterList();
            }
        },
        loadScheduledSlots: async function () {
            if (this.stationId) {
                let stationId = this.stationId;
                let start = moment().format("YYYY-MM-DD");

                this.controls['ROSTER_LIST'].items = []; // control.setItems("ROSTER_LIST", [], this.storeId);
                let sDsParams = {
                    sDsParams: {
                        force: true
                    }
                };
                library.showLoadingIndicator('roster');
                let slotCount = 20000;
                this.sDs.post("er_SISRosterList", false, false, slotCount, true, true, this.signinStore.fields.sch, this.signinStore.fields.vol, stationId, sDsParams).then((response) => {
                    library.hideLoadingIndicator('roster');
                    if (response && response.status === 'success') {
                        let oppIds = [];
                        let volIds = [];
                        let rosterList = [];
                        let volunteers = {};
                        for (let i in response.data.slotsList) {
                            if (i === 'length') continue;
                            let slot = library.cloneObj(response.data.slotsList[i]);
                            if (oppIds.indexOf(slot.OPPORTUNITY_ID) === -1) oppIds.push(slot.OPPORTUNITY_ID);
                            slot.value = slot.SS_REPEATED_ID;
                            if (typeof slot.ID !== 'string') slot.ID += '';
                            let baseSlotIdLen = 6;
                            slot.value1 = slot.ID.substring(0, slot.ID.length - baseSlotIdLen);
                            slot.text = slot.OPP_TITLE + " " + slot.SS_START_TIME + " - " + slot.SS_FINISH_TIME;
                            let schRefPlVolList = response.data.schRefPlVolList;
                            if (
                                (schRefPlVolList[slot.value] || schRefPlVolList[slot.value1])
                            ) {
                                let slotID = schRefPlVolList[slot.value] ? slot.value : slot.value1;
                                let schRefPlVol = library.cloneObj(schRefPlVolList[slotID]);
                                for (let j in schRefPlVol) {
                                    if (j === 'length') continue;
                                    let rosterVol = {};
                                    rosterVol.volunteer = library.cloneObj(schRefPlVol[j]);
                                    volunteers[rosterVol.volunteer.ID] = library.cloneObj(rosterVol.volunteer);
                                    if (volIds.indexOf(j) === -1) volIds.push(j);

                                    rosterVol.slot = library.cloneObj(slot);
                                    rosterVol.group_size = parseInt(rosterVol.volunteer.GROUPSIZE, 10) || 1;
                                    rosterVol.show_group_size = 0;
                                    rosterVol.SLOT_SIGNED_IN = false;
                                    rosterVol.TIME_LOGGED = false;
                                    rosterList.push(rosterVol);
                                }
                            }
                        }
                        /* istanbul ignore next */
                        if (typeof (response.data.forgottenSignOutList) !== "undefined") {
                            for (let q in response.data.forgottenSignOutList["oppIDs"]) {
                                if (q === 'length') continue;
                                let tmpOppID = library.cloneObj(response.data.forgottenSignOutList["oppIDs"][q]);
                                if (oppIds.indexOf(tmpOppID) === -1) oppIds.push(tmpOppID);
                            }
                            for (let q in response.data.forgottenSignOutList["volIDs"]) {
                                if (q === 'length') continue;
                                let tmpVolID = library.cloneObj(response.data.forgottenSignOutList["volIDs"][q]);
                                if (volIds.indexOf(tmpVolID) === -1) volIds.push(tmpVolID);
                                for (let i in response.data.schRefPlVolList) {
                                    if (i === 'length') continue;
                                    if (response.data.schRefPlVolList[i][tmpVolID]) {
                                        volunteers[tmpVolID] = library.cloneObj(response.data.schRefPlVolList[i][tmpVolID]);
                                    }
                                }
                            }
                        }
                        this.rosterList = rosterList;
                        this.volunteers = volunteers;

                        if (oppIds.length) {
                            this.oppIds = oppIds;
                        }
                        if (volIds.length) {
                            this.volIds = volIds;
                        }
                        this.loadLogBookEntries();
                    } else {
                        this.filterRosterList();
                    }
                });
            }
        },
        filterRosterList: function () {
            if (this && this.stationId && this.controls && this.controls !== null) {
                let rosterList = library.cloneObj(this.rosterList);
                let rosterForgotList = library.cloneObj(this.rosterForgotList);
                let hideAfterSignIn = library.cloneObj(this.controls["SIS_HIDE_VOL_FROM_ROSTER"].value);
                let sortBy = library.cloneObj(this.controls["SIS_SORT_ROSTER_BY"].value);
                if (typeof sortBy === 'number') sortBy += "";
                let tmpRosterList = [];
                let signedVolunteers = [];
                for (let i in rosterList) {
                    if (i === 'length') continue;
                    rosterList[i].SORT_FN = rosterList[i].volunteer.VOL_FIRST_NAME;
                    rosterList[i].SORT_LN = rosterList[i].volunteer.VOL_LAST_NAME;
                    if (moment(rosterList[i].slot.SS_DATE + ' ' + rosterList[i].slot.SS_START_TIME).isValid()) {
                        rosterList[i].SORT_ST = moment(rosterList[i].slot.SS_DATE + ' ' + rosterList[i].slot.SS_START_TIME).toDate();
                    } else {
                        rosterList[i].SORT_ST = rosterList[i].slot.SS_DATE + ' ' + rosterList[i].slot.SS_START_TIME;
                    }
                    if (rosterList[i].SLOT_SIGNED_IN) {
                        signedVolunteers.push(rosterList[i].volunteer.ID);
                    }
                }
                for (let i in rosterForgotList) {
                    if (i === 'length') continue;
                    signedVolunteers.push(rosterForgotList[i].volunteer.ID);
                }
                for (let i in rosterList) {
                    if (i === 'length') continue;
                    if (hideAfterSignIn && (rosterList[i].SLOT_SIGNED_IN || rosterList[i].TIME_LOGGED)) continue;
                    if (!rosterList[i].SLOT_SIGNED_IN && signedVolunteers.indexOf(rosterList[i].volunteer.ID) !== -1) continue;
                    tmpRosterList.push(rosterList[i]);
                }
                switch (sortBy) {
                    case "0":
                        tmpRosterList = library.sortObject(tmpRosterList, ['SORT_ST', 'SORT_FN']);
                        break;
                    case "1":
                        tmpRosterList = library.sortObject(tmpRosterList, ['SORT_FN']);
                        break;
                    case "2":
                        tmpRosterList = library.sortObject(tmpRosterList, ['SORT_LN', 'SORT_FN']);
                        break;
                }
                this.controls['ROSTER_EMPTY_LIST'].value = '';
                if (!tmpRosterList.length) {
                    this.controls['ROSTER_EMPTY_LIST'].value = "No volunteers available to Sign-in/out.";
                }
                let listControls = [];
                let groupSize = {};
                let signinButton = {};
                let signinAgainButton = {};

                for (let i in tmpRosterList) {
                    if (i === 'length') continue;
                    listControls = [];
                    groupSize = library.cloneObj(this.controls['ROSTER_GROUP_SIZE']);
                    groupSize.name = 'ROSTER_GROUP_SIZE__' + i;
                    groupSize.value = 0;
                    listControls.push(groupSize);
                    signinButton = library.cloneObj(this.controls['ROSTER_SIGN_IN']);
                    signinButton.name = 'ROSTER_SIGN_IN__' + i;
                    if (tmpRosterList[i].group_size > 1) {
                        signinButton.label = "Sign In with " + tmpRosterList[i].group_size;
                    } else {
                        signinButton.label = "Sign In";
                    }
                    listControls.push(signinButton);
                    signinAgainButton = library.cloneObj(this.controls['ROSTER_SIGN_IN_AGAIN']);
                    signinAgainButton.name = 'ROSTER_SIGN_IN_AGAIN__' + i;
                    signinAgainButton.text = true;
                    listControls.push(signinAgainButton);
                    listControls.forEach((control) => {
                        let controlStoreIndex = createStoreIndex(this.storeId, control.name);
                        controlStore().addControl(control, this, controlStoreIndex);
                    });
                }
                this.rosterFilteredList = tmpRosterList;
                this.rosterForgotList = rosterForgotList;
            }
        },
        async onPropsUpdate() {
            let controls = [];
            for (let cName in this.controls) {
                if (cName === 'length') continue;
                if (typeof this.signinStore.controls[cName] !== 'undefined') {
                    let tmpControl = {
                        ...this.controls[cName],
                        ...this.signinStore.controls[cName]
                    };
                    delete tmpControl.default;
                    controls.push(tmpControl);
                }
            }
            controls.forEach((control) => {
                let controlStoreIndex = createStoreIndex(this.storeId, control.name);
                controlStore().addControl(control, this, controlStoreIndex);
            });
            this.loadScheduledSlots();
        }
    }
};

componentStore.initComponent(rosterCmp, rosterConfig, '@signin/roster.vue');
export { rosterConfig, rosterCmp };
export default rosterCmp;

</script>

<style scoped>
    :deep(.time-logged) {
        text-align: center;
        padding-bottom: 0px;
    }

    :deep(.time-logged .control.e-control) {
        margin-top: 0;
    }

    :deep(.list-item-title){
        font-size: 18px;
        font-weight: 500;
    }

    :deep(.list-item-subtitle){
        font-style: italic;
        color: #777;
        padding: 0;
        display: block;
    }

    :deep(.signed-in-checkmark) {
        font-size: 24px;
        padding: 6px 0 0 10px;
        color: #049d14;
    }

    :deep([name="ROSTER_LIST"] [id^="element_"]) {
        min-height: 90px;
    }
</style>
